import { CompanyDetails, DunsNumber, EntitlementsResponse, NavigateUrlReq, ProfileInfo, UserProfileResponse } from '@customTypes/ItemTypes';
import { PRODUCT_DETAILS_CONSTANTS } from '@helpers/constants';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
// Define a service using a base URL and expected endpoints
export const api = createApi({
    reducerPath: 'api', // A unique key that will be used for the reducer in the store
    baseQuery: fetchBaseQuery({ baseUrl: '/services/' }), // Your API base URL
    endpoints: (builder) => ({
        getEntitlementsAgainstDuns: builder.mutation({
            query: (activeDuns: string) => ({
                url: '/entitlements/get-entitlements-by-duns',
                method: 'POST',
                body: { dunsArray: [activeDuns] },
            }),
        }),
        getCompanyInfo: builder.query<CompanyDetails,{dunsNumber: DunsNumber, idaas_uuid?: string, type?: string}>({
            query: (args) => {
                const { dunsNumber, idaas_uuid, type = 'normal' } = args;
                let url = `/entitlements/getCompanyInfo?dunsNumber=${dunsNumber}`;
                if (idaas_uuid) {
                    url += `&idaas_uuid=${idaas_uuid}`;
                }
                if (type) {
                    url += `&type=${type}`;
                }
                return url;
            },
        }),
        getAllEntitlements: builder.query<EntitlementsResponse, void>({
            query: () => '/entitlements/all',
        }),
        getAssignedEntitlements: builder.query<EntitlementsResponse, void>({
            query: () => '/entitlements/assigned',
        }),
        getLegalEntitlements: builder.query<EntitlementsResponse, void>({
            query: () => '/entitlements/legal-terms',
        }),
        getNavigateUrl: builder.mutation<any, NavigateUrlReq>({
            query: (data: NavigateUrlReq) => {
                const { NavigateCredit } = PRODUCT_DETAILS_CONSTANTS;
                return ({
                    url: '/entitlements/getNavigateUrl',
                    method: 'POST',
                    body: {
                        ...data,
                        applicationId: NavigateCredit?.appId,
                        noDunsFlow: data.noDunsFlow ?? false, 
                        pendingDuns: data.pendingDuns ?? false, 
                    },
                });
            }
        }),
        getProfileInfo: builder.query<UserProfileResponse, void>({
            query: () => '/auth/getUserProfile',
        }),
        updateProfileInfo: builder.mutation({
            query: (profileJson: ProfileInfo) => ({
                url: '/auth/updateUserProfile',
                method: 'PUT',
                body: profileJson,
            })
        }),
        accessSubscriptions: builder.query<any,any>({
            query: (product: any) => `/auth/accessSubscriptions?subscriber_number=${product.subscriber_number}&app_id=${product.app_id}`
        }),
    }),
});

export const { useGetEntitlementsAgainstDunsMutation, useLazyGetCompanyInfoQuery, useLazyGetAllEntitlementsQuery, useLazyGetAssignedEntitlementsQuery, useLazyGetLegalEntitlementsQuery, useLazyGetProfileInfoQuery, useUpdateProfileInfoMutation, useLazyAccessSubscriptionsQuery, useGetNavigateUrlMutation } = api;
